import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'api';

export type LightningDetails = {
  flashCurrentKa?: number;
  flashPolarity: 'P' | 'N';
  flashType?: 0 | 1;
  flashDurationNs?: number;
  flashTime: Date;
  sensorCount?: number;
};

type UseLightningDetailsQueryProps = {
  id?: string | number;
};

type UseLightningDetailsQuery = Omit<
  UseQueryResult<LightningDetails, Error>,
  'data'
> & {
  lightningDetails?: LightningDetails;
};

export const useLightningDetailsQuery = (
  props: UseLightningDetailsQueryProps,
): UseLightningDetailsQuery => {
  const { id } = props;

  const { data: lightningDetails, ...results } = useQuery({
    queryKey: ['lightning-flash', id],
    queryFn: async () => {
      const response = await API.get<LightningDetails>(
        `lightning/flashes/${id}`,
      );
      return response.data;
    },
    enabled: Boolean(id),
    staleTime: 1000 * 60 * 5,
  });

  return { ...results, lightningDetails };
};
